import { useEffect, useState } from "react";

function TownSelector({ setSelectedTown, goBack }) {
  const towns = [
    "Nairobi",
    "Mombasa",
    "Kiambu",
    "Juja",
    "Ruiru",
    "Kisumu",
    "Nakuru",
    "Eldoret",
    "Machakos",
    "Kithimani-Yatta",
    "Kitui",
    "Thika",
    "Meru",
    "Nyeri",
    "Embu",
    "Kakamega",
    "Kericho",
    "Naivasha",
    "Malindi",
    "Garissa",
    "Nanyuki",
    "Kitale",
    "Kayole",
    "Rongai"
  ];

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div className="app-page">
      <div className="page-container">

        {/* Back Button */}
        <button
          className="primary-btn"
          onClick={goBack}
          style={{
            width: "170px",
            marginBottom: "30px"
          }}
        >
          ⬅ Back
        </button>

        {/* Main Card */}
        <div className="page-card">

          <h1 className="page-title" style={{ color: "#000" }}>
            MNHouseFinder
          </h1>

          <p
            className="page-subtitle"
            style={{
              maxWidth: "800px",
              margin: "0 auto 35px auto",
              color: "#555",
              fontSize: "18px",
              lineHeight: "1.8"
            }}
          >
            Select the town that you prefer to see available rental houses across Kenya.
          </p>

          {/* Town Grid */}
          <div className="town-grid">
            {towns.map((town, index) => (
              <button
                key={town}
                onClick={() => setSelectedTown(town)}
                className={`town-btn ${loaded ? "show" : ""}`}
                style={{
                  animationDelay: `${index * 60}ms`
                }}
              >
                📍 {town}
              </button>
            ))}
          </div>

        </div>
      </div>

      {/* ANIMATION STYLES */}
      <style>{`
        .town-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 15px;
        }

        .town-btn {
          background: #ffd600;
          color: #000;
          border: none;
          padding: 15px;
          border-radius: 14px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 4px 10px rgba(0,0,0,0.12);

          opacity: 0;
          transform: translateY(25px);
        }

        .town-btn.show {
          animation: slideFade 0.5s ease forwards;
        }

        .town-btn:hover {
          transform: translateY(-4px);
          transition: all 0.2s ease;
          box-shadow: 0 10px 18px rgba(0,0,0,0.18);
        }

        .town-btn:active {
          transform: scale(0.96);
        }

        @keyframes slideFade {
          from {
            opacity: 0;
            transform: translateY(25px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default TownSelector;